import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from "@angular/core";
import { isEmpty } from "lodash";
import moment from "moment";
import { CONSTANT } from "src/app/constant";
import { DateRange } from "../../constants/angular-datetime-picker.const";

@Component({
	selector: "app-cbta-daterange-filter",
	templateUrl: "./cbta-daterange-filter.component.html",
	styleUrls: ["./cbta-daterange-filter.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaDaterangeFilterComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() startDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 15);

	@Input() endDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

	@Input() enabled = false;

	@Output() dateRangeSelected = new EventEmitter<DateRange>();
	DATE_FORMAT = CONSTANT.DATE_FORMAT;
	dateFilterEnabled = false;

	constructor() {}

	ngOnInit(): void {
		this.dateFilterEnabled = this.enabled;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["enabled"]) {
			this.dateFilterEnabled = this.enabled;
		}
	}

	ngAfterViewInit(): void {
		this.emitChange();
	}

	setDateFilterEnabled(enabled: boolean): void {
		if (this.dateFilterEnabled === enabled) {
			return;
		}

		this.dateFilterEnabled = enabled;
		this.emitChange();
	}

	handleStartDateChange(startDate: string): void {
		if (!isEmpty(startDate)) {
			this.startDate = moment(new Date(startDate), "MM DD, YYYY").toDate();

			this.emitChange();
		}
	}

	handleEndDateChange(endDate: string): void {
		if (!isEmpty(endDate)) {
			this.endDate = moment(new Date(endDate), "MM DD, YYYY").toDate();

			this.emitChange();
		}
	}

	emitChange(): void {
		if (!this.dateFilterEnabled) {
			this.dateRangeSelected.emit({ enabled: false });
			return;
		}

		if (this.startDate instanceof Date && this.endDate instanceof Date) {
			if (this.endDate >= this.startDate) {
				this.dateRangeSelected.emit({
					enabled: true,
					startDate: this.startDate,
					endDate: this.endDate,
				});
			}
		}
	}
}
